import {BTooltip, createBootstrap} from "bootstrap-vue-next";

// Add the necessary CSS
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import 'bootstrap/dist/css/bootstrap.min.css'

const originalDelay = BTooltip.props.delay
BTooltip.props.delay = {
  ...originalDelay,
  default: () => ({ show: 0, hide: 0 })
}

export default {
  install(app) {
    app.use(createBootstrap());
  }
};

